import script from "./BagIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BagIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__